import React from 'react';
import {
  Box, Button, VStack, FormControl, FormLabel, Input, Text, 
  Flex, IconButton, InputGroup, InputLeftElement, Spinner,
  Select, Icon
} from '@chakra-ui/react';
import { AddIcon, SearchIcon } from '@chakra-ui/icons';
import { FaBuilding } from 'react-icons/fa';
import { FiEdit2, FiTrash2 } from 'react-icons/fi';
import '../../Styles/theme/PasswordModel.css';
import MailImage from '../../Images/Icons/mail.png';

const EmailManagerModal = ({
  visible,
  frequentEmails,
  searchText,
  onSearchChange,
  isLoading,
  newEmailInfo,
  onNewEmailChange,
  companies,
  onShowCompanyList,
  onSelectEmail,
  onEditEmail,
  onDeleteEmail,
  onAddEmail,
  isEditingEmail,
  onClose
}) => {
  if (!visible) return null;
  
  // 确保 frequentEmails 是数组
  const emailsArray = Array.isArray(frequentEmails) ? frequentEmails : [];
  const hasEmails = emailsArray.length > 0;

  return (
    <div className="model-overlay">
      <div 
        className="model" 
        style={{
          width: '650px',
          maxWidth: '90vw',
          maxHeight: '90vh', 
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img src={MailImage} alt="Mail" style={{ width: '50px', height: '50px', marginRight: '10px' }} />
              <div style={{ fontWeight: 'bold', fontSize: '20px' }}>常用信箱管理</div>
            </div>
            <Button
              bg="#1C734A"
              colorScheme="green"
              borderRadius="full"
              leftIcon={<Icon as={FaBuilding} boxSize={4} />}
              onClick={onShowCompanyList}
            >
              查看公司列表
            </Button>
          </div>
          <InputGroup mb={4}>
            <InputLeftElement pointerEvents="none">
              <SearchIcon color="gray.300" />
            </InputLeftElement>
            <Input
              placeholder="收件者、公司名稱、信箱"
              value={searchText}
              onChange={e => onSearchChange(e.target.value)}
              bg="white"
              borderRadius="md"
              boxShadow="sm"
            />
          </InputGroup>
        </div>
        <Box p={4} bg="white" borderRadius="md" mb={4} borderWidth="1px" boxShadow="sm" mt={6}>
          <Text fontWeight="medium" mb={3}>
            {isEditingEmail ? '編輯收件人' : '新增常用收件人'}
          </Text>
          <VStack spacing={4} align="stretch" mb={5}>
            <FormControl isRequired>
              <FormLabel>電子信箱</FormLabel>
              <Input
                placeholder="電子信箱"
                size="md"
                value={newEmailInfo.email}
                onChange={(e) => onNewEmailChange('email', e.target.value)}
              />
            </FormControl>
                
            <FormControl isRequired>
              <FormLabel>收件者姓名</FormLabel>
              <Input
                placeholder="收件者姓名"
                size="md"
                value={newEmailInfo.name}
                onChange={(e) => onNewEmailChange('name', e.target.value)}
              />
            </FormControl>
                
            <FormControl isRequired>
              <FormLabel>選擇收件人所屬公司</FormLabel>
              <Select 
                placeholder="選擇公司"
                value={String(newEmailInfo.receiver_company_id) || ''}
                onChange={(e) => {
                  const selectedCompanyId = Number(e.target.value);
                  const selectedCompany = companies.find(c => c.id === selectedCompanyId);
                  if (selectedCompany) {
                    onNewEmailChange('company', selectedCompany.company_name);
                    onNewEmailChange('receiver_company_id', selectedCompanyId);
                    onNewEmailChange('recipient_company_no', selectedCompany.recipient_company_no || '');
                    onNewEmailChange('recipient_place_no', selectedCompany.recipient_place_no || '');
                  }
                }}
              >
                {companies.map(company => (
                  <option key={company.id} value={String(company.id)}>
                    {company.company_name}
                  </option>
                ))}
              </Select>
            </FormControl>

            <FormControl isRequired>
              <FormLabel>運作人管編</FormLabel>
              <Input
                placeholder="請輸入運作人管制編號"
                size="md"
                value={newEmailInfo.recipient_company_no || ''}
                onChange={(e) => onNewEmailChange('recipient_company_no', e.target.value)}
              />
            </FormControl>

            <FormControl isRequired>
              <FormLabel>運作場所管編</FormLabel>
              <Input
                placeholder="請輸入運作場所管制編號"
                size="md"
                value={newEmailInfo.recipient_place_no || ''}
                onChange={(e) => onNewEmailChange('recipient_place_no', e.target.value)}
              />
            </FormControl>
          </VStack>
          <Button
            bg="#1C734A"
            color="white"
            leftIcon={<AddIcon />}
            borderRadius="md"
            fontWeight="medium"
            fontSize="sm"
            px={4}
            py={2}
            width="100%"
            onClick={onAddEmail}
            _hover={{ bg: "#145a39" }}
            isLoading={isLoading}
            loadingText={isEditingEmail ? "更新中..." : "新增中..."}
          >
            {isEditingEmail ? '更新收件人' : '新增常用信箱'}
          </Button>
        </Box>
        <Text fontWeight="medium" mb={2}>常用收件人列表</Text>
        
        {/* 常用收件人列表 - 經過改進的版本 */}
        <div style={{marginBottom: "20px", width: "100%"}}>
          {isLoading ? (
            <Box p={4} textAlign="center" bg="white" borderRadius="md">
              <Spinner size="md" color="#1C734A" />
              <Text mt={2}>載入中...</Text>
            </Box>
          ) : !hasEmails ? (
            <Box p={4} textAlign="center" bg="gray.50" borderRadius="md">
              <Text>無常用收件人資料</Text>
            </Box>
          ) : (
            <Box 
              maxH="300px" 
              minH="150px"
              overflowY="auto" 
              borderWidth="1px" 
              borderRadius="md"
              bg="white"
              display="block"
              width="100%"
              position="relative"
              zIndex={1}
            >
              {emailsArray.map((email) => (
                <Flex
                  key={email.id || email.email}
                  p={3}
                  mb={3}
                  bg="white"
                  borderRadius="md"
                  boxShadow="sm"
                  borderWidth="1px"
                  direction="row"
                  align="center"
                  justify="space-between"
                  _hover={{ bg: "gray.50" }}
                  cursor="pointer"
                  onClick={() => onSelectEmail(email)}
                >
                  <Box flex="1">
                    <Text fontWeight="semibold" mb={1}>{email.name}</Text>
                    <Text fontSize="sm" color="gray.600" mb={1}>{email.email}</Text>
                    <Box display="inline-block">
                      <Text
                        fontSize="sm"
                        display="inline-block"
                        color="gray.800"
                        bg="gray.100"
                        px={2}
                        py={0.5}
                        borderRadius="md"
                      >
                        {email.company}
                      </Text>
                    </Box>
                  </Box>
                  <Flex>
                    <IconButton
                      size="sm"
                      icon={<FiEdit2 size="16px" />}
                      aria-label="編輯"
                      colorScheme="blue"
                      variant="ghost"
                      onClick={(e) => {
                        e.stopPropagation();
                        onEditEmail(email.id, e);
                      }}
                      mr={2}
                    />
                    <IconButton
                      size="sm"
                      icon={<FiTrash2 size="16px" />}
                      aria-label="刪除"
                      colorScheme="red"
                      variant="ghost"
                      onClick={(e) => {
                        e.stopPropagation();
                        onDeleteEmail(email.id || email.email, e);
                      }}
                    />
                  </Flex>
                </Flex>
              ))}
            </Box>
          )}
        </div>
        <Box mt={4} p={2} position="sticky" bottom={0} bg="white" borderTop="1px solid #E2E8F0">
          <Button
            mt={4}
            size="md"
            colorScheme="gray"
            variant="outline"
            onClick={onClose}
            width="100%"
          >
            返回
          </Button>
        </Box>
      </div>
    </div>
  );
};

export default EmailManagerModal;
